type LogoProps = {
  className?: string;
  size?: number;
  href?: string; // Optional: if logo links to home
  ariaLabel?: string; // For accessibility
};

import LogoSVG from '@/assets/svgs/logo.svg';

export function Logo({
  className = '',
  size = 96,
  href = '/',
  ariaLabel,
}: LogoProps) {
  const label = ariaLabel || 'Home';

  const logoContent = (
    <div
      className="text-foreground/80 hover:text-foreground relative flex items-center justify-center p-2 transition-colors focus:outline-none"
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <LogoSVG
        width={size}
        height={size}
        className="h-full w-full fill-current"
        aria-hidden="true"
        focusable="false"
      />
    </div>
  );

  return (
    <div className={`flex items-center gap-4 ${className}`} role="banner">
      {href ? (
        <a href={href} aria-label={label}>
          {logoContent}
        </a>
      ) : (
        <span aria-label={label}>{logoContent}</span>
      )}
      <span
        className="font-heading from-primary to-accent bg-gradient-to-r bg-clip-text text-2xl font-bold text-transparent"
        aria-hidden="true"
      >
        Portfolio
      </span>
    </div>
  );
}
